import React from 'react';

import { useRouter } from 'next/router';

import { useAuth0 } from '@auth0/auth0-react';

import { EXCLUDED_ROUTE_PROTECTION_PATHS } from '@itp/talent/components/routeProtection/excludedRouteProtectionPaths';
import { useLocalAuth } from '@itp/talent/context/localAuthContext';

type RouteProtectionProps = {
  children?: React.ReactNode;
};

export const RouteProtection: React.FC<RouteProtectionProps> = ({ children }) => {
  const router = useRouter();
  const { isAuthenticated: isAuth0Authenticated, isLoading } = useAuth0();
  const { isAuthenticated: isLocalAuthenticated } = useLocalAuth();
  const isAuthenticated = isAuth0Authenticated || isLocalAuthenticated;

  React.useEffect(() => {
    const { error, error_description, state } = router.query;
    if (error) {
      const queryParams = new URLSearchParams();
      if (error) queryParams.append('error', error as string);
      if (error_description) queryParams.append('error_description', error_description as string);
      if (state) queryParams.append('state', state as string);
      router.replace(`/error?${queryParams.toString()}`);
      return;
    }
    if (
      !isLoading &&
      !isAuthenticated &&
      !EXCLUDED_ROUTE_PROTECTION_PATHS.includes(router.pathname)
    ) {
      sessionStorage.setItem('returnTo', router.asPath);
      router.replace('/sign-in');
    }
  }, [isAuthenticated, isLoading, router]);

  React.useEffect(() => {
    if (isAuthenticated) {
      const returnTo = sessionStorage.getItem('returnTo');
      if (returnTo) {
        sessionStorage.removeItem('returnTo');
        router.replace(returnTo);
      }
    }
  }, [isAuthenticated, router]);

  if (
    isLoading ||
    (!isAuthenticated && !EXCLUDED_ROUTE_PROTECTION_PATHS.includes(router.pathname))
  ) {
    return null;
  }

  return <>{children}</>;
};
